<ul [hidden]="alwaysVisible ? false : (isHidden | async)">
  <li>
    <button (click)="setPage(0)" [disabled]="cannotBeDecreased | async">
      <span class="bi bi-skip-start-fill"></span>
    </button>
  </li>
  <li>
    <button (click)="decreasePage()" [disabled]="cannotBeDecreased | async">
      <span class="bi bi-caret-left-fill"></span>
    </button>
  </li>

  @for (page of numberOfPagesAsRange | async; track page) {
  <li>
    <a (click)="setPage(page)" [class.active]="(activePage | async) === page">
      {{ page + 1 }}
    </a>
  </li>
  }

  <li>
    <button (click)="increasePage()" [disabled]="cannotBeIncreased | async">
      <span class="bi bi-caret-right-fill"></span>
    </button>
  </li>
  <li>
    <button (click)="setPageToLast()" [disabled]="cannotBeIncreased | async">
      <span class="bi bi-skip-end-fill"></span>
    </button>
  </li>
  @if (customPageSizeOptions) {
  <li class="mx-3">
    <select [ngModel]="pageSize" (ngModelChange)="changePageSize($event)">
      @for (option of customPageSizeOptions; track option) {
      <option [value]="option">{{ option }}</option>
      }
    </select>
  </li>
  }
</ul>
